import { render, staticRenderFns } from "./SearchGiftList.vue?vue&type=template&id=a94c73bc&scoped=true"
import script from "./SearchGiftList.vue?vue&type=script&lang=js"
export * from "./SearchGiftList.vue?vue&type=script&lang=js"
import style0 from "./SearchGiftList.vue?vue&type=style&index=0&id=a94c73bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94c73bc",
  null
  
)

export default component.exports